import React from 'react';
import { makeStyles } from '@mui/styles';
import { Box, Typography, Button } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const WHATSAPP_GROUP_URL = 'https://chat.whatsapp.com/FCn8zNrwZL23GmJUZZTeWo';
const COMPETITIONS_URL = 'https://political-radio-5d2.notion.site/Crack-the-Product-Case-with-Case-Master-AI-October-Edition-Competitions-3e65783f9a6881008c5dcf6145d382da?source=copy_link';

const useStyles = makeStyles((theme) => ({
  bannerContainer: {
    width: '100%',
    background: '#F4F8FD',
    borderBottom: '1px solid #E3EBF5',
    // Horizontal padding mirrors CaseHeader so the banner lines up with the nav.
    padding: theme.spacing(4, 37.5),
    [theme.breakpoints.down('xl')]: {
      padding: theme.spacing(4, 15),
    },
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(4, 10),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3, 5),
    },
  },
  bannerContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(6),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing(3),
    },
  },
  bannerText: {
    ...theme.typography['body02-bold'],
    color: '#0A3F63',
    borderLeft: '3px solid #1961BF',
    paddingLeft: theme.spacing(3),
  },
  buttonsContainer: {
    display: 'flex',
    gap: theme.spacing(3),
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
  },
  bannerButton: {
    ...theme.typography['body02-bold'],
    textTransform: 'none',
    whiteSpace: 'nowrap',
    borderRadius: '6px',
    padding: theme.spacing(2, 5),
    [theme.breakpoints.down('md')]: {
      flex: 1,
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2.5, 4),
    },
  },
  joinButton: {
    color: '#0A3F63',
    background: '#E8F8EE',
    border: '1.5px solid #7FD6A0',
    minWidth: '150px',
    '&:hover': {
      background: '#D7F3E1',
    },
  },
  whatsAppIcon: {
    color: '#25D366',
  },
  exploreButton: {
    color: '#0A3F63',
    background: '#EEF3FB',
    border: '1.5px solid #9DB8E0',
    '&:hover': {
      background: '#E1EAF8',
    },
  },
}));

const CaseBanner = () => {
  const classes = useStyles();

  const openInNewTab = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Box className={classes.bannerContainer}>
      <Box className={classes.bannerContent}>
        <Typography className={classes.bannerText}>
          Join the Case Master AI community, meet fellow product thinkers, and take part in our product case competitions.
        </Typography>

        <Box className={classes.buttonsContainer}>
          <Button
            className={`${classes.bannerButton} ${classes.joinButton}`}
            startIcon={<WhatsAppIcon className={classes.whatsAppIcon} />}
            onClick={() => openInNewTab(WHATSAPP_GROUP_URL)}
          >
            Join Us
          </Button>
          <Button
            className={`${classes.bannerButton} ${classes.exploreButton}`}
            endIcon={<ArrowForwardIcon />}
            onClick={() => openInNewTab(COMPETITIONS_URL)}
          >
            Explore our case competitions
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default CaseBanner;
